import { BasicRequest } from "./basicRequest";

export class ActivateAdoptedMoovDefinitionRequest extends BasicRequest {
    
    public moovDefinitionId!: number;
    public active: boolean = false;

    constructor() {
        super();
    }
}